/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EmployeeLocation } from '../../models/employee-location';

export interface GetEmployeeLocationByEmployeeId$Plain$Params {

/**
 * The employee ID
 */
  employeeId: string;
}

export function getEmployeeLocationByEmployeeId$Plain(http: HttpClient, rootUrl: string, params: GetEmployeeLocationByEmployeeId$Plain$Params, context?: HttpContext): Observable<StrictHttpResponse<EmployeeLocation>> {
  const rb = new RequestBuilder(rootUrl, getEmployeeLocationByEmployeeId$Plain.PATH, 'get');
  if (params) {
    rb.path('employeeId', params.employeeId, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/plain', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<EmployeeLocation>;
    })
  );
}

getEmployeeLocationByEmployeeId$Plain.PATH = '/api/EmployeeLocation/ByEmployee/{employeeId}';
